<div class="cv-system-info">
    <div class="header flex-row">
        <div class="back-button" (click)="goBack($event)">
            <i class="fa fa-arrow-left"></i>
        </div>
        <div class="system-header flex-row">
            <div class="flex-row">
                <div>
                    <img src="assets/img/brand/ClassValuation-logo-XS-SM.png">
                </div>
                <div class="status">
                    <span>|</span> <label>Status</label>
                </div>
            </div>
            <div class="flex-row status-name">
                <div>
                    <label><i class="icon fas fa-check operational"></i> Operational</label>
                </div>
                <!--                <div>-->
                <!--                    <label><i class="icon fas fa-exclamation-triangle incident"></i> Incident</label>-->
                <!--                </div>-->
                <div>
                    <label><i class="icon fas fa-minus-circle down"></i> Down</label>
                </div>
                <!--                <div>-->
                <!--                    <label><i class="icon fas fa-wrench maintenance"></i> Maintenance</label>-->
                <!--                </div>-->
            </div>
        </div>
    </div>

    <div class="content">
        <div class="flex-row package-version">
            <div>
                <i class="fas fa-box-open"></i>
                <cv-version-label [showSubmodules]="false"></cv-version-label>
            </div>
        </div>
        <div class="flex-row content-header">
            <div class="status-service">
                <label>Current Status and Service</label>
            </div>
            <div class="version">
                <label>Version</label>
            </div>
            <div class="version">
                <label>Release Notes</label>
            </div>
            <div class="detail">
                <label>Details</label>
            </div>
        </div>

        <div class="systems flex-column">
            <div class="system-status" *ngFor="let system of systems">
                <div class="flex-row system-main">
                    <div class="flex-row description-container">
                        <div class="current-status">
                            <i class="icon fas fa-check operational"></i>
                        </div>
                        <div class="flex-column system-logo">
                            <div>
                                <img src="{{system.app.logo}}">
                            </div>
                            <div>
                                <label>Operating Normal</label>
                            </div>
                        </div>
                    </div>
                    <div class="flex-column system-version">
                        <div class="name">{{system.version.name}}</div>
                        <div class="version">{{system.version.number}}</div>
                    </div>
                    <div class="flex-column release-notes">
                        <div (click)="openNotes($event, system)">View</div>
                    </div>
                    <div class="action">
                        <i class="fas"
                           [ngClass]="{'fa-angle-right': !system.subDetail.open, 'fa-angle-down': system.subDetail.open}"
                           (click)="system.subDetail.open = !system.subDetail.open;">
                        </i>
                    </div>
                </div>
                <div class="system-sub-details" *ngIf="system.subDetail.open">
                    <div class="system-dependencies flex-column" *ngIf="system.version.name === 'cv.invision-desktop.ux'">
                        <div class="flex-row dependency">
                            <cv-change-state></cv-change-state>
                        </div>

                    </div>
                    
                    <div class="system-dependencies flex-column">
                        <div class="flex-row dependency">
                            <div class="flex-column">
                                <i class="icon fas fa-cog"></i>
                            </div>
                            <div class="col-3">
                                <label class="h6 text-uppercase">Component</label>
                            </div>
                            <div class="col-1">
                                <label class="h6 text-uppercase">Type</label>
                            </div>
                            <div class="col-1 pl-5">
                                <label class="h6 text-uppercase">Version</label>
                            </div>
                        </div>
                    </div>
                    <div class="system-dependencies flex-column" *ngFor="let dep of system.dependencies">
                        <div class="flex-row dependency">
                            <div class="flex-column">
                                <i class="icon fas fa-check operational"></i>
                            </div>
                            <div class="col-3">
                                <label>{{dep.name}}</label>
                            </div>
                            <div class="col-1">
                                <label>{{dep.type}}</label>
                            </div>
                            <div class="col-1 status">
                                <label>{{dep.version}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<cv-release-notes
        *ngIf="releasesNotes.open"
        (closeDialog)="releasesNotes.open = false;">
</cv-release-notes>